import React, { JSX } from 'react';
import { Box, TextField } from '@mui/material';

interface ProfileFieldProps {
  label: string;
  value: string;
  editing: boolean;
  editValue: string;
  onChange: (value: string) => void;
  icon?: React.ReactNode;
  multiline?: boolean;
}

function ProfileField({
  label,
  value,
  editing,
  editValue,
  onChange,
  icon,
  multiline,
}: ProfileFieldProps): JSX.Element {
  if (editing) {
    return (
      <Box className="entry">
        <TextField
          fullWidth
          multiline={multiline}
          rows={multiline ? 3 : undefined}
          label={label}
          value={editValue}
          variant="outlined"
          onChange={(e): void => onChange(e.target.value)}
        />
      </Box>
    );
  }
  return <ProfileStaticField icon={icon} label={label} value={value} />;
}

function ProfileStaticField({
  icon,
  label,
  value,
}: {
  icon?: React.ReactNode;
  label: string;
  value: string;
}): JSX.Element {
  return (
    <Box className="entry">
      <Box className="title">
        {icon}
        {label}
      </Box>
      <Box className="value">{value}</Box>
    </Box>
  );
}

export { ProfileField, ProfileStaticField };
